export var RootQueryParam;
(function (RootQueryParam) {
    RootQueryParam["Purchase"] = "purchase";
    RootQueryParam["Settings"] = "settings";
    RootQueryParam["DemoToken"] = "demo-token";
    RootQueryParam["AcceptSubscriptionInvite"] = "accept-subscription-invite";
    RootQueryParam["UserRequest"] = "user-request";
    RootQueryParam["AppViewRoute"] = "route";
})(RootQueryParam || (RootQueryParam = {}));
